import HttpClient from "core/http";

import { REACT_APP_RESTFUL_BASE_URL_FOT_API } from "AppConfig";
import { requestIncomeSectionOtp } from "core/http/incomeOtpBridge";
import { store } from "redux-store/store";
import { logoutStart } from "modules/Auth/redux/logout";

class baseHttp extends HttpClient {
  private static classInstance?: baseHttp;
  private constructor() {
    super(REACT_APP_RESTFUL_BASE_URL_FOT_API, {
      onLogout: (payload) => {
        store.dispatch(logoutStart({ toastMsg: payload?.toastMsg ?? "" }));
      },
      onRequireOtp: (signal) => requestIncomeSectionOtp(signal),
    });
  }

  public static getInstance() {
    if (!this.classInstance) {
      this.classInstance = new baseHttp();
    }
    return this.classInstance;
  }
}

const baseHttpService = baseHttp.getInstance();
export default baseHttpService;
